import React from "react";
import { Link } from "../util/router.js";
import "./HeroSection.scss";

function WhyAlcatraz(props) {
  return (
    <div>
        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container why_alcatraz_section">
            <div className="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first">
                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js " id="div_341d_5">
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js  gdlr-core-sync-height-content">
                        <div className="gdlr-core-pbf-element">
                            <img src={require('../upload/whyalca.jpg').default} width="90%" />
                            {/* <div className="gdlr-core-skill-bar-item gdlr-core-item-pdlr gdlr-core-item-pdb  gdlr-core-size-small gdlr-core-type-round">
                                <div className="gdlr-core-skill-bar">
                                    <div className="gdlr-core-skill-bar-head gdlr-core-title-font"><span className="gdlr-core-skill-bar-title">Branding</span><span className="gdlr-core-skill-bar-right">90%</span></div>
                                    <div className="gdlr-core-skill-bar-progress">
                                        <div className="gdlr-core-skill-bar-filled gdlr-core-js" data-width="90" id="div_341d_6"></div>
                                    </div>
                                </div>
                                <div className="gdlr-core-skill-bar">
                                    <div className="gdlr-core-skill-bar-head gdlr-core-title-font"><span className="gdlr-core-skill-bar-title">Graphic Design</span><span className="gdlr-core-skill-bar-right">100%</span></div>
                                    <div className="gdlr-core-skill-bar-progress">
                                        <div className="gdlr-core-skill-bar-filled gdlr-core-js" data-width="100" id="div_341d_7"></div>
                                    </div>
                                </div>
                                <div className="gdlr-core-skill-bar">
                                    <div className="gdlr-core-skill-bar-head gdlr-core-title-font"><span className="gdlr-core-skill-bar-title">Social Marketing</span><span className="gdlr-core-skill-bar-right">85%</span></div>
                                    <div className="gdlr-core-skill-bar-progress">
                                        <div className="gdlr-core-skill-bar-filled gdlr-core-js" data-width="85" id="div_341d_8"></div>
                                    </div>
                                </div>
                                <div className="gdlr-core-skill-bar">
                                    <div className="gdlr-core-skill-bar-head gdlr-core-title-font"><span className="gdlr-core-skill-bar-title">Product Design</span><span className="gdlr-core-skill-bar-right">90%</span></div>
                                    <div className="gdlr-core-skill-bar-progress">
                                        <div className="gdlr-core-skill-bar-filled gdlr-core-js" data-width="90" id="div_341d_9"></div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="gdlr-core-pbf-column gdlr-core-column-30 ">
                <div className="gdlr-core-pbf-column-content-margin gdlr-core-js " id="div_341d_1">
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js  gdlr-core-sync-height-content">
                        <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" id="div_341d_2">
                                <div className="gdlr-core-title-item-title-wrap">
                                    <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" id="h3_341d_0">Why buy our Alcatraz tour package?<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider" ></span></h3></div>
                            </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                            <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" id="div_341d_3">
                                <div className="gdlr-core-text-box-item-content" id="div_341d_4">
                                    {/* <p>The federal prison on Alcatraz Island in the chilly waters of California’s San Francisco Bay housed some of America’s most difficult and dangerous felons during its years of operation from 1934 to 1963. </p> */}
                                    {/* <img src={require('../upload/alcatraz-map.jpg').default} /> */}
                                    {/* <img src={require('../upload/alcatraz-graphic.jpg').default} /> */}
                                    <p>Alcatraz Cruises does sell blocks of tickets to authorized tour companies who combine them with other tours. Buying the packages that include Alcatraz is a best way to get tickets for Alcatraz, and basically that's the only way of getting tickets, when they are sold out at the main box office.</p>
                                    <p>Are you thinking about visiting Muir Woods or Sausalito, doing a bay cruise, bike over the golden gate bridge or taking a city tour? There are no bargain or discounted tickets for Alcatraz per se, but if you are planning to take another tour or tours while you're here, you may save some money by doing a combination of Alcatraz plus another tour(s). In some cases, it's actually more expensive to do the combos, but may be the only way of snagging tickets for sold out days.</p>
                                    {/* <div className="info_banner">
                                        <p>Please note that we will be sold out of Alcatraz tickets many days this year. Order your Alcatraz Tickets today to avoid missing out on the opportunity to see the most popular tourist attraction in San Francisco.</p>
                                    </div> */}
                                    {/* <p>Today, historic Alcatraz Island, which was also the site of a U.S. military prison from the late 1850s to 1933, is a popular tourist destination.</p> */}
                                    {/* <div className="mt-5">
                                        <Link to="/tours" className="default_button">Visit Alcatraz Now</Link>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    // <Section
    //   bg={props.bg}
    //   textColor={props.textColor}
    //   size={props.size}
    //   bgImage={props.bgImage}
    //   bgImageOpacity={props.bgImageOpacity}
    // >
    //   <Container>
    //     <Row className="align-items-center">
    //       <Col lg={5} className="text-center text-lg-left">
    //         <SectionHeader
    //           title={props.title}
    //           subtitle={props.subtitle}
    //           size={1}
    //           spaced={true}
    //         />

    //         <LinkContainer to={props.buttonPath}>
    //           <Button variant={props.buttonColor} size="lg">
    //             {props.buttonText}
    //           </Button>
    //         </LinkContainer>
    //       </Col>
    //       <Col className="offset-lg-1 mt-5 mt-lg-0 ">
    //         <figure className="HeroSection__image-container mx-auto">
    //           <Image src={props.image} fluid={true} />
    //         </figure>
    //       </Col>
    //     </Row>
    //   </Container>
    // </Section>
  );
}

export default WhyAlcatraz;
